// extracted by mini-css-extract-plugin
module.exports = {"root":"az_mW","disabled":"az_nW","edgeStart":"az_oW","edgeEnd":"az_pW","colorInherit":"az_qW","colorPrimary":"az_rW","colorSecondary":"az_sW","sizeSmall":"az_tW","label":"az_uW"};